//
// ┌─────────────────────┐
// │ DO NOT EDIT BY HAND │
// └─────────────────────┘
//
// Generated by build.mjs in zinnia-icons
//
import { mapPropsToSvgProps, Props } from "../utils";
function IconNavAssets(iconProps: Props) {
  const props = mapPropsToSvgProps(iconProps);
  return <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M4 5H10L12 7H20V19H2V21H22V5H13L11 3H2V17H4V5Z" fill="currentColor" /><path d="M13 7L7 14H11V19L17 12H13V7Z" fill="currentColor" /></svg>;
}
export default IconNavAssets;